export class BNLAutocomplete {
	init() {
		const autocompleteInputs =
			document.querySelectorAll<HTMLInputElement>("input[list]");

		autocompleteInputs.forEach(autocompleteInput => {
			const list = autocompleteInput.getAttribute("list") ?? "";
			const datalist = document.getElementById(list);
			if (datalist === null) {
				return;
			}
			autocompleteInput.addEventListener("input", event => {
				const inputEvent = event as InputEvent;
				// This event means a datalist option was selected.
				if (inputEvent?.inputType !== "insertReplacementText") {
					return;
				}

				// If the selected datalist option has a data-link attribute, use that as the url to send the user to.
				const disorderLink = datalist
					.querySelector(`option[value='${inputEvent.data}']`)
					?.getAttribute("data-link");
				if (!disorderLink) {
					return;
				}

				window.location.href = disorderLink;
			});
		});
	}
}

document.addEventListener("DOMContentLoaded", () => {
	const autocomplete = new BNLAutocomplete();
	autocomplete.init();
});
